<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        下一代Serverless技术驱动的<br>
        星汉未来AI应用平台——AIPilot
      </a-typography-title>
      <a-typography-paragraph>
        {{
          '轻松管理不断涌现的AI应用与大模型，统一调度云端及本地的GPU、CPU等计算资源。' +
          'AIPilot支持大型模型推理，并已对接八家以上大模型厂商API，助力企业快速、高效、低成本的将AI融入多元生产场景。' +
          '基于众多专利技术，AIPilot能在一台8核16G的笔记本电脑上部署20个热门AI应用，企业只需万元成本，即可构建专属的AI应用引擎。'
        }}
      </a-typography-paragraph>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_1"
                  @click="clickToWhiteBook()">
          免费部署
        </a-button>
        <!--<a-button type="link" class="button_n_1"-->
        <!--          @click="$Store.Page().openModal('modalFormCollection','demo')">-->
        <!--  联系我们-->
        <!--</a-button>-->
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_banner',
  methods: {
    /**
     * 点击去白皮书
     */
    clickToWhiteBook(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open('https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd');
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productSchedulX/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 120px 0 50px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_white, @banner_title, true);
}

div.ant-typography {
  max-width: 550px;
  margin: 20px 0 0;
  .font(justify, @text+@line, @color_white, @text);
}

.ant-space {
  margin-top: 20px;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo, @color_white, @banner_title_mo, true);
  }
  
  div.ant-typography {
    margin: 10px 0 0;
    .font(justify, @text_mo+@line_mo, @color_white, @text_mo);
  }
  
  .ant-space {
    margin-top: 10px;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>